import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-kanban-resend-code',
  templateUrl: './modal-kanban-resend-code.component.html',
  styles: []
})
export class ModalKanbanResendCodeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
